export default __webpack_public_path__ + "static/favicon-c0197aa00576a5253edb81e4666d8baf.ico";